export default "__VITE_ASSET__b98466ac__"